/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import Helmet from 'react-helmet';

import { LocationService } from 'shared/services';
import { image_thumbnail } from 'shared/images/images';
import { ADSENSE } from 'shared/settings/config';
import { addDataLayer } from 'shared/utils/utils';
import { Adsense } from 'shared/utils/Adsense';
import { HeartPlusIcon } from 'shared/assets/icons';
import { Loader } from 'shared/hoc/loader/Loader';
import { SALE_LIST_TYPE, SaleListHoc } from '../HOC/SaleListHoc';
import { Breadcrumbs } from 'shared/hoc/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_TYPE_CONFIG } from 'shared/hoc/breadcrumbs/config';

import './SalesListForLocation.scss';

const pageSize = 4
/**
@Author Karthik

@param

@return html code for sales list based on location
**/

const SalesListForLocation = (props) => {
    const user = useSelector(state => state.user);

    const [pageLoading, setPageLoading] = useState(true);
    const [locationDetail, setLocationDetail] = useState({});
    const [favLocIds, setFavLocIds] = useState([]);
    const [isFav, setIsFav] = useState(false);
    const [h1Tag, setH1Tag] = useState()
    const [h2Tag, setH2Tag] = useState();
    const [seoDetail, setSeoDetail] = useState({ pageTitle: "CTBids", pageDescription: "CTBids buyers web app" });

    useEffect(() => {
        getRequiredData();
        getFavoriteLocations();
    }, []);

    const getRequiredData = async () => {
        const locationCode = props.match.params.locationcode;
        const locationStateCode = props.match.params.locationstatecode;
        const postData = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "page": { 'size': pageSize },
            "filter": [{ "field": "locationstatecode", "value": locationStateCode, "op": "=", "join": "AND" }]
        };
        if (locationCode) {
            postData.filter.push({ "field": "locationcode", "value": locationCode, "op": "=", "join": "AND" });
        } else {
            postData.filter.push({ "field": "locationcode", "value": null, "op": "IS", "join": "AND" });
        }

        setPageLoading(true);
        LocationService.getLocationList(postData).then(res => {
            const data = res.data.data[0];

            if ( data ) {
                setLocationDetail(data);
                setPageLoading(false);

                getLocationSeoList(data.id).then(response => {
                    if ( response.data.length > 0 && typeof response.data[0].textcontent === 'string' ) {
                        const data = JSON.parse(response.data[0].textcontent);
                        
                        setSeoDetail(prevState => {
                            prevState.pageTitle = data.pagetitle;
                            prevState.pageDescription = data.metadescription;

                            return {...prevState};
                        })   
                        setH1Tag(data.h1tag);
                        setH2Tag(data.h2tag);
                    }
                    
                }).catch(error => {

                });
            } else {
                // TODO
                // this.locationNotFound();
            }
        }).catch(error => {
            // this.locationNotFound();
            setPageLoading(false);
        });
    };

    const getLocationSeoList = (locationId) => {
        const seoData = {
            "filter": [
                { "field": "locationid", "value": locationId, "op": "=", "join": "AND" }
            ]
        };

        return new Promise((resolve, reject) => {
            LocationService.SEOLocationList(seoData).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject();
            });
        });
    };

    const getFavoriteLocations = () => {
        const postData = {
            field: ["id", "locationid", "buyerid"],
            filter: [],
            sort: [{ field: "id", direction: "asc" }],
            page: { size: 999 }
        };

        if (user.id) {
            try {
                LocationService.getFavoriteLocation(postData).then(response => {
                    const favLocIds = response.data.data.map(x => x.locationid);
                    setFavLocIds(favLocIds);
                });
            } catch (error) {
                setFavLocIds([]);
            }
        } else {
            setFavLocIds([]);
        }
    };

    const isFavoriteLocation = (location) => {
        return favLocIds.includes(location.id);
    }

    const favoriteLocation = (event, location) => {
        if (isFavoriteLocation(location)) {
            removeFavoriteLocation(location);
            setIsFav(false);
        } else {
            addFavoriteLocation(location);
            setIsFav(true);
        }
    };

    const addFavoriteLocation = (location) => {
        const postData = { data: { locationid: location.id } };

        LocationService.addFavoriteLocation(postData).then(res => {
            getFavoriteLocations();
        }).catch(() => {
        });
    };

    const removeFavoriteLocation = (location) => {
        const postData = { data: { locationIds: [{ id: location.id }] } };

        LocationService.deleteFavoriteLocation(postData).then(() => {
            getFavoriteLocations();
        }).catch(() => {
        });
    };


    const getProfileImage = () => {
        const locationImage = {};
        if (locationDetail.imageurl) {
            const image = locationDetail.imageurl.split(',');
            image.forEach(x => {
                const temp = x.split('#*#');
                locationImage[temp[0]] = temp[1];
            });
        }
        return locationImage.profile ? locationImage.profile : image_thumbnail;
    };

    const openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        let dataLayerData = {
            'event': 'location_visit',
            'title': locationDetail.title
        }
        addDataLayer(dataLayerData);
    }

    return (
        <div className="sale-list-for-location">
            <Helmet>
                <title>{seoDetail.pageTitle}</title>
                <meta name='description' content={seoDetail.pageDescription} />
                <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                <link rel="canonical" href={`https://ctbids.com${props.match.url}`} />
            </Helmet>
            <div className="d-none">
                    {
                        h1Tag ?  <h1>{h1Tag}</h1> : ''
                    }
                    {
                        h2Tag ? <h2>{h2Tag}</h2> : ''
                    }
                </div>

            {
                pageLoading ? 
                <Loader /> : 
                <div className='content'>
                    <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.SALE_LIST_FOR_LOCATION} options={{ locationTitle: locationDetail.title }} />

                    <div className='d-flex flex-column flex-md-row flex-grow-1'>
                        <Col xs={12} sm={12} md={4} lg={3}>
                            <div className="location-detail">
                                <div className={`title loc-title ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.title}</div>
                                <div className={`state ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.state}</div>
                                <div className="image-container p-4">
                                    <img className='location-image' src={getProfileImage()} alt="location-image"></img>
                                </div>
                                <div className={`contact ${locationDetail.salecount > 0 ? "text-secondary" : "text-inactive"}`}>{locationDetail.contactname}</div>
                                <div className={`${locationDetail.salecount > 0 ? "text-secondary" : "text-dimmed"}`}>{locationDetail.salecount ? locationDetail.salecount : 0} Active Sale(s)</div>
                                {locationDetail?.auctioneerlicense && <div className='text-secondary mt-3' style={{ wordBreak: "break-all" }}>License: {locationDetail?.auctioneerlicense}</div>}
                                <div className='d-flex flex-column align-items-center justify-content-center gap-3 p-3'>
                                    <div className='d-flex gap-1 align-items-center justify-content-center flex-wrap'>
                                        <div>
                                            <a href={`tel:${locationDetail.phone}`}>{locationDetail.phone}</a>
                                        </div>
                                        <div>|</div>
                                        <div className='text-decoration-underline'>
                                            <a href={`mailto:${locationDetail.email}`}>{locationDetail.email}</a>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='d-flex w-100 gap-1'>
                                    <Button className={`${isFavoriteLocation(locationDetail) ? 'btn-secondary' : 'btn-white'} rounded border-secondary border-2 heart-resp`} onClick={(event) => { favoriteLocation(event, locationDetail) }} style={{ border: "1px solid" }} aria-label="heart-icon">{HeartPlusIcon}</Button>
                                    <Button className=' w-100 btn-grey-light  rounded text-bold' onClick={() => { openInNewTab(locationDetail.website) }}>View Website</Button>
                                </div>
                            </div>

                            {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.ITEM_VIEW.slotId} /> : ""}
                            
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={9} className='list-section'>
                            { pageLoading ? null : <SaleListHoc props={props} type={SALE_LIST_TYPE.ESTATESALEFORLOCATION} locationDetail={locationDetail} /> }
                        </Col>
                    </div>
                    <div>
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.FOOTER.slotId} /> : ""}
                    </div>
                </div>
            }
        </div>
    )
};

export default SalesListForLocation;